'use strict';

/*global BasicBarcodes*/
/*global app*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global resSuccess*/

function BarcodesHandlingUnits(containerId) {
  BasicBarcodes.call(this, containerId);
}

BarcodesHandlingUnits.prototype = $.extend({}, BasicBarcodes.prototype, {
  constructor: 'BarcodesHandlingUnits',

  //----------------------------------------------------------------------------

  onAfterAddItem: function onAfterAddItem($row) {
    var _this = this;

    var barcode = $row.find('input[name$="[Barcode]"]').val();

    blockElement(_this.$container);
    services.get('barcode-service').findHandlingUnit(barcode, function (res, resData) {
      unBlockElement(_this.$container);

      if (res !== resSuccess) {
        return app.viewErrorMessage(app.t('barcode.unknown'), function () {
          _this.removeItem($row);
        });
      }

      $row.find('input[name$="[RID]"]').val(resData.RID);

      blockElement(_this.$container);
      services.get('handling-unit-service').getStockQuantity(resData.RID, function (res, resData) {
        unBlockElement(_this.$container);

        if (res !== resSuccess) {
          return;
        }

        if (resData.Available <= 0) {
          return app.viewErrorMessage(app.t('handling_unit.no_available'), function () {
            _this.removeItem($row);
          });
        }
      });
    });

    return _this;
  },

  //----------------------------------------------------------------------------

});
